"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
var _shared = require("./shared");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  tooltip: {
    position: 'relative'
  },
  tooltip__highlight: {
    boxShadow: '1px 1px 5px 1px var(--tooltip-background)'
  },
  tooltipContent: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    bottom: '5px',
    left: '5px',
    width: 'auto',
    height: 'auto',
    backgroundColor: 'var(--tooltip-background)',
    color: 'var(--tooltip-colour)',
    padding: '5px',
    border: '2px solid var(--tooltip-background)',
    borderRadius: '4px',
    transition: 'all ease-in-out 0.5s',
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
    zIndex: 10,
    fontSize: '1rem'
  },
  tooltipContent__inPortal: {
    transition: "all 0.6s ease-in-out 0.25s"
  },
  tooltipContent__wrap: {
    whiteSpace: 'pre'
  },
  tooltipContent__center: {
    left: '50%',
    transform: 'translateX(-50%)'
  },
  tooltipContent__fixed: _objectSpread({
    position: 'fixed'
  }, (0, _shared.media)(['xxs'], {
    left: '5px !important'
  })),
  tooltipContent__hovered: {
    visibility: 'visible',
    opacity: 1
  }
};
var _default = exports["default"] = (0, _nano.sheet)(styles);